import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { reactSelectCustomStyleCms, numberWithCommas } from 'helper';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import NumberFormat from 'react-number-format';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import { InputTemplate } from 'modules/common/components/inputComponents';

import * as actions from '../actions';
import * as c from '../constant';

function ApproveConfirmationEngrModal({
  approveEngr,
  approving,
  id,
  trackingNo,
  getItem,
  getFeesList,
  feesList,
  refreshList,
}) {
  const [formData, setFormData] = useState({
    amount: '',
    annual_fee: '',
    inspection_fee: [],
    tracking_no: trackingNo,
    year: new Date().getFullYear(),
  });
  const [isEditing, setIsEditing] = useState('');
  const setModal = useContext(ModalContext);
  const toggleEdit = (item) => (e) => {
    e.preventDefault();
    setIsEditing(_.get(item, 'description'));
    setFormData({
      ...formData,
      annual_fee: _.get(item, 'description'),
      amount: _.get(item, 'amount'),
    });
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      inspection_fee: _.get(formData, 'inspection_fee'),
    };
    approveEngr(id, args, () => {
      setModal({ isOpen: false });
      refreshList(id);
      getItem(id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getFeesList({ department: 'ENGINEERING DEPARTMENT' });
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      inspection_fee: feesList.map((item) => {
        return {
          description: _.get(item, 'attributes.name'),
          amount: _.get(item, 'attributes.amount'),
        };
      }),
    });
  }, [feesList]);

  const formValidation = {
    amount: 'required',
    annual_fee: 'required',
  };

  const validateForm = useFormValidator(formData, formValidation);

  useEffect(() => {
    validateForm.onSetObjectRules(formValidation);
  }, [formData]);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleUpdateFee = (e) => {
    e.preventDefault();
    const feeList = _.get(formData, 'inspection_fee').filter(
      (item) => item.description !== isEditing
    );
    feeList.splice(
      _.get(formData, 'inspection_fee').findIndex(
        (i) => i.description === isEditing
      ),
      0,
      {
        description: _.get(formData, 'annual_fee'),
        amount: _.get(formData, 'amount') || 0,
      }
    );
    setFormData({
      ...formData,
      inspection_fee: feeList,
      amount: '',
      annual_fee: '',
    });
    setIsEditing('');
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="full-group-v2">
          <div className="form-row">
            <div className="col-12 mt-3">
              <table className="transaction-table table table-striped table-sm">
                <tbody>
                  <tr>
                    <th
                      className="p-2 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                      width="40%"
                    >
                      Annual Inspection Fee
                    </th>
                    <th
                      className="p-2 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                      width="40%"
                    >
                      Amount
                    </th>
                    <th
                      className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                      width="20%"
                    />
                  </tr>
                  {!_.isEmpty(_.get(formData, 'inspection_fee')) ? (
                    _.get(formData, 'inspection_fee')?.map((item) => (
                      <React.Fragment key={item.name}>
                        {_.get(item, 'description') === isEditing ? (
                          <tr style={{ height: '3.5rem' }}>
                            <td>
                              <InputTemplate
                                htmlFor="annual_fee"
                                containerClassName="col-12 px-0"
                                labelClassName="font-weight-bold"
                                placeholder="Fee"
                                styles={reactSelectCustomStyleCms()}
                                className="full-input-v2"
                                id="annual_fee"
                                name="annual_fee"
                                type="input"
                                disabled
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    annual_fee: e.target.value || '',
                                  })
                                }
                                value={_.get(formData, 'annual_fee')}
                                components={{ IndicatorSeparator: () => null }}
                              />
                            </td>
                            <td>
                              <InputTemplate
                                htmlFor="amount"
                                containerClassName="col-12"
                                labelClassName="font-weight-bold"
                                withCustomInputComponent={() => (
                                  <NumberFormat
                                    name="amount"
                                    id="amount"
                                    placeholder="PHP 0"
                                    className="full-input-v2"
                                    onValueChange={(values) => {
                                      const { floatValue } = values;
                                      setFormData({
                                        ...formData,
                                        amount: floatValue || 0,
                                      });
                                    }}
                                    isNumericString
                                    thousandSeparator
                                    displayType="input"
                                    prefix="PHP "
                                    value={_.get(formData, 'amount') || ''}
                                  />
                                )}
                              />
                            </td>
                            <td className="text-center align-middle">
                              <button
                                className="py-1 btn btn-primary cms-bg-color-primary cms-outline-primary"
                                type="button"
                                disabled={
                                  _.isEmpty(_.get(formData, 'annual_fee')) ||
                                  _.get(formData, 'amount') < 0 ||
                                  typeof _.get(formData, 'amount') !== 'number'
                                }
                                onClick={handleUpdateFee}
                              >
                                <span className="font-weight-bold">
                                  Save Changes
                                </span>
                              </button>
                            </td>
                          </tr>
                        ) : (
                          <tr style={{ height: '3.5rem' }}>
                            <td className="text-dark align-middle">
                              {_.get(item, 'description') || '-'}
                            </td>
                            <td className="text-dark align-middle">
                              <b>PHP</b> &nbsp;
                              {numberWithCommas(_.get(item, 'amount')) || '-'}
                            </td>
                            <td className="text-center">
                              {isEditing === '' && (
                                <button
                                  type="button"
                                  className="btn btn-blank px-2"
                                  onClick={toggleEdit(item)}
                                >
                                  <i className="far fa-edit icon-edit cms-bg-color-primary" />
                                </button>
                              )}
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr className="text-dark text-center">
                      <td className="text-dark text-center" colSpan="3">
                        No Fees
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <InputTemplate
              // isInputMask
              title="Tracking No."
              htmlFor="tracking_no"
              containerClassName="col-12"
              labelClassName="font-weight-bold"
              // formValidatorMsg={validateForm.renderMessage("tracking_no")}
              // Input component props
              placeholder=""
              // className="full-input-v2 text-uppercase"
              className="full-input-v2"
              id="tracking_no"
              name="tracking_no"
              type="text"
              autoComplete="none"
              onChange={onChange}
              value={_.get(formData, 'tracking_no')?.toUpperCase() || ''}
              disabled
            />
            <InputTemplate
              title="Year"
              htmlFor="year"
              labelClassName="font-weight-bold"
              containerClassName="col-12"
              withCustomInputComponent={() => (
                <DateInputPicker
                  showYearPicker
                  inputClassName="full-input form-input-record-v2"
                  placeholder="YYYY"
                  btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                  onChange={handleOnChangeDate('year')}
                  value={_.get(formData, 'year')?.toString() || ''}
                  disabled
                />
              )}
            />
          </div>
          <div className="mt-2 pt-2 d-flex col-12 cms-text-primary cms-bg-color-primary-light">
            <p>
              Note: By clicking approve, you consent that all the data were
              thoroughly validated and reviewed. The details of this transaction
              will be sent to the internal system of Las Pi&#x00f1;as City for
              recording. This will be sent to the Business Permit Licensing
              Officer for their assessment.
            </p>
          </div>
          <div className="d-flex justify-content-end">
            <button
              disabled={approving || !_.isEmpty(isEditing)}
              type="submit"
              className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            >
              <span className="font-weight-bold">
                {approving ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
              </span>
            </button>
            <button
              disabled={approving}
              type="button"
              onClick={closeModal}
              className="mt-3 btn btn-default"
            >
              <span className="font-weight-bold">Cancel</span>
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

ApproveConfirmationEngrModal.propTypes = {
  approveEngr: PropTypes.instanceOf(Function).isRequired,
  approving: PropTypes.bool.isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  trackingNo: PropTypes.string.isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
  getFeesList: PropTypes.instanceOf(Function).isRequired,
  feesList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  approving: api.loading.indexOf(c.APPROVE) > -1,
  feesList: _.get(api, `${c.GET_FEES_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ApproveConfirmationEngrModal);
